import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/client')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/client/GetClientList.js